export default __webpack_public_path__ + "static/media/walle.f82bf0af.png";